import NavigationItemRecord from '../../../../../records/NavigationItemRecord';
import getDeviceFeature from '../get-device-feature';
import getDisplayType from '../get-display-type';
import getLinkClass from './get-link-class';
import adjustLinkId from './adjust-link-id';
export default function getClassicLink(link) {
  // Sstarred properties are not in the payload.
  // Commented properties are probably not needed but kept for reference
  var linkId = adjustLinkId(link.navigationId);
  var configuredLink = {
    anchorTagAttributes: link.dataAttributes || {},
    // ***
    // anchorTagAttributesAsString = 'role=\\u0022link\\u0022' / ***
    // queryParameters = {} // ***
    linkId: linkId,
    linkName: link.label,
    listItemClassName: getLinkClass(link),
    derivedUrl: link.url || '',
    navigationUrl: link.url || '',
    // ***
    linkDisabled: false,
    // ***
    linkStaticConfig: {
      hostApp: '',
      // ***
      linkId: linkId,
      linkNonSamlAttributes: link.dataAttributes,
      linkNonSamlAttributesAsString: '',
      // ***
      linkSamlAttributes: link.dataAttributes,
      linkSamlAttributesAsString: '',
      // ***
      nonSamlUrl: '',
      // ***
      samlUrl: '',
      // ***
      secureSessionURL: true,
      // ***
      navigationUrl: link.url || '',
      // ***
      // nonSamlLinkAttributesAsString // repeated?
      // samlLinkAttributesAsString // repeated?
      samlNavigation: getDisplayType(link) === 'saml'
    },
    secureSessionURL: true,
    // ***
    samlNavigation: getDisplayType(link) === 'saml',
    displayType: getDisplayType(link),
    deviceFeature: getDeviceFeature(link)
  };
  return [linkId, NavigationItemRecord(configuredLink)];
}